export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_10.239f8014.jpg";